import {Box, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import SettingsEntityHeader from "../../../layout/SettingsEntityHeader";
import DetailsLoading from "crqlar-react-common/dist/components/DetailsLoading";
import {useEntity} from "crqlar-react-common/dist/components/useEntity";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import IncertConfigForm from "./IncertConfigForm";
import {IncertConfig} from "crqlar-react-common/dist/models/integrations/incert/incert.config";
import {IncertService} from "crqlar-react-common/dist/services/integrations/incert/incert.service";
import EmptyState from "crqlar-react-common/dist/components/EmptyState";
import Button from "@mui/material/Button";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import {useNavigate} from "react-router-dom";

const IncertConfigDetails = () => {

    useTrackScreenVisit('system incert config details')

    const {t} = useTranslation()
    const navigate = useNavigate()

    const incertConfigData = useEntity<IncertConfig>({
        get: async () => {
            return await IncertService.find()
        },
        create: IncertService.create,
        update: IncertService.update,
        delete: (id) => IncertService.delete({id: [id]}),
        isValid: (incertConfig) => {
            return !!incertConfig.name
        },
        cleanupBeforeSave: (incertConfig) => {
            return {
                ...incertConfig,
                name: incertConfig.name?.trim()
            }
        }
    })

    const handleCreate = () => {
        incertConfigData.startCreate({
            pollerConfig: {
                fullSync: {
                    profileDaysPast: 1000,
                    reservationDaysPast: 365,
                    staleTimeoutMinutes: 5 * 60,
                },
                quickSync: {
                    staleTimeoutMinutes: 10,
                    syncPeriodMinutes: 5
                }
            }
        } as IncertConfig)
    }

    const emptyState = (
        <EmptyState
            icon={<ElectricalServicesIcon/>}
            title={t('No integration configured')}
            description={t('Create the configuration to connect this integration.')}
        >
            <Button variant={'contained'} onClick={handleCreate}>
                {t('Create')}
            </Button>
        </EmptyState>
    )

    const content = (
        incertConfigData.isMissing ? (
            <>
                <SettingsEntityHeader
                    title={undefined}
                    data={incertConfigData}
                    back={() => navigate('/system')}
                />

                <Stack
                    sx={{
                        width: '100%',
                        maxWidth: '900px',
                        mx: 'auto',
                        mt: 3,
                    }}
                >
                    {emptyState}
                </Stack>
            </>
        ) : (
            <IncertConfigForm incertConfigData={incertConfigData}/>
        )
    )

    return (
        <Box sx={{width: '100%', pb: 8}}>
            {incertConfigData.loading ? (
                <>
                    <SettingsEntityHeader
                        title={t('Incert')}
                        data={incertConfigData}
                        back={() => navigate('/system')}
                    />
                    <DetailsLoading/>
                </>
            ) : content}
        </Box>
    );
}

export default IncertConfigDetails;
